<template>
  <div class="div">
    <!-- <img src="https://homeimage.ksaxshop.com/tou.png" alt="" class="w100"> -->
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {

} from "../../api/api";

export default {
  components: {},
  created() {

  },
  data() {
    return {
    };
  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style scoped>
.content-az {
  padding: 0 !important;
  border: none !important;
  overflow-y: hidden !important;
}
.div {
  position: relative;
  width: 100%;
  /* background: #E9F2FB; */
  background: #fff;
  min-height: 100%;
}

img {
  display: block;
}

.main {
  /* background-color: #fff; */
  margin: 0 auto;
  /* border-radius: 24px; */
  padding: 12px;
  position: relative;
}
</style>
